/**
 * セミナー詳細 参加費用 1:無料
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEE_FREE = {
    label: '無料',
    value: 1,
};
/**
 * セミナー詳細 参加費用 2:有料
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEE_PAID = {
    label: '有料',
    value: 2,
};
/**
 * セミナー詳細 参加費用
 */
export const SEMINAR_INFORMATION_PARTICIPATION_FEES = [
    SEMINAR_INFORMATION_PARTICIPATION_FEE_FREE,
    SEMINAR_INFORMATION_PARTICIPATION_FEE_PAID,
];
